import API from 'services/API';

/**
 * @typedef {Object} Attachment
 * @property {number} id
 * @property {boolean} multiple
 * @property {number} maxFiles
 * @property {Object[]} files
 */

/**
 * @typedef {Object} MoveFilesParams
 * @property {Attachment[]} attachments
 * @property {number} fileId
 * @property {number} sourceId
 * @property {number} sourceIndex
 * @property {number} destinationId
 * @property {number} destinationIndex
 */

/**
 * @typedef {Object} UpdateCategoryParams
 * @property {string} endpoint
 * @property {number} fileId
 * @property {number} newCategoryId
 */

/**
 * @param {Attachment[]} attachments
 * @param {number} destinationId
 * @returns {boolean}
 */
export const hasReachedMaxFiles = ({ attachments, destinationId }) =>
  attachments.some(
    category =>
      category.id === destinationId &&
      !category.multiple &&
      category.files.length >= category.maxFiles
  );

/**
 * @param {MoveFilesParams} params
 * @returns {Attachment[]}
 */
export const moveFileIntoSelectedCategory = ({
  attachments,
  fileId,
  sourceId,
  sourceIndex,
  destinationId,
  destinationIndex
}) => {
  const sourceFiles = [];
  const destinationFiles = [];
  let movingFile = [];

  attachments.forEach(category => {
    if (category.id === sourceId) {
      category.files.forEach(item => sourceFiles.push(item));
      movingFile = category.files.filter(att => att.id === fileId);
    }

    if (category.id === destinationId) {
      category.files.forEach(item => destinationFiles.push(item));
    }
  });

  const movedFile = {
    ...movingFile[0],
    file_type_id: destinationId,
    fileType: { id: destinationId },
    isLoading: true,
    message: 'Updating file...'
  };
  movingFile[0] = movedFile;

  sourceFiles.splice(sourceIndex, 1);
  destinationFiles.splice(destinationIndex, 0, movingFile[0]);

  const movedAttachments = attachments.map(category => {
    const { id, files } = category;

    const fileMapping = {
      [destinationId]: destinationFiles,
      [sourceId]: sourceFiles
    };
    return { ...category, files: fileMapping[id] || files };
  });

  return movedAttachments;
};

/**
 * @param {UpdateCategoryParams} params
 * @returns {Promise<void>}
 */
export const updateCategoryByEndpoint = ({ endpoint, fileId, newCategoryId }) => {
  const url = `${endpoint}/${fileId}`;

  return new Promise((resolve, reject) => {
    API.put(url, { file_type_id: newCategoryId })
      .then(() => {
        resolve();
      })
      .catch(error => {
        reject(error);
      });
  });
};
